export function isRegistration(registration) {
    return 'name' in registration;
}
export function isSerializedSecurityObjectInfo(registration) {
    return 'security_name' in registration;
}
